import styled from 'styled-components';

import { PlaceholderWrapper } from '_utils/components/Corporate';

export const Primary = styled(PlaceholderWrapper)``;
